import { Text } from '@farmersdog/corgi-x';

import Stethoscope from './assets/stethoscope.svg';
import styles from './VetRecommendedPlanPill.module.css';

interface VetRecommendedPlanPillArgs {
  isMobile: boolean;
}

export function VetRecommendedPlanPill({
  isMobile,
}: VetRecommendedPlanPillArgs) {
  return (
    <span className={styles.vetRecommendedPlan}>
      <Stethoscope className={styles.icon} />
      <Text variant={isMobile ? 'heading-12' : 'heading-16'} bold>
        Vet-Recommended Plan
      </Text>
    </span>
  );
}
